"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuidRegex = exports.extractIssueId = void 0;
const uuidRegex = exports.uuidRegex = /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}/;
const singleIssueRegex = new RegExp("^issues/(?<issueId>".concat(uuidRegex.source, ")"));
const extractIssueId = url => {
  var _singleIssueRegex$exe;
  return (_singleIssueRegex$exe = singleIssueRegex.exec(url)) === null || _singleIssueRegex$exe === void 0 || (_singleIssueRegex$exe = _singleIssueRegex$exe.groups) === null || _singleIssueRegex$exe === void 0 ? void 0 : _singleIssueRegex$exe.issueId;
};
exports.extractIssueId = extractIssueId;
//# sourceMappingURL=urlExtractors.js.map